import { Col, Container, InternalLink, InternalLinkProps, Row } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

const StyledBreakingP = styled.p`
  white-space: break-spaces;
  word-break: break-word;
`;

export const StyledHeader = styled(StyledBreakingP)`
  font-weight: normal;
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: 6px;
`;

export const StyledTime = styled(StyledHeader)`
  color: ${({ theme }) => theme.colors.gray14};
`;

export const StyledSubject = styled(StyledBreakingP) <{ unread: boolean }>`
  font-size: 14px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-weight: initial;

  ${({ unread }) => unread && `
    font-weight: bold;
  `}
`;

export const StyledRightCol = styled(Col)`
  text-align: right;
`;

export const StyledContainer = styled(Container) <{ unread: boolean }>`
  border-bottom: 1px solid ${({ theme }) => theme?.colors.gray4};

  &:first-child {
    border-top: 1px solid ${({ theme }) => theme?.colors.gray4};
  }

  ${({ unread, theme }) => unread && `
    background: ${theme?.colors.blue12};
  `}
`;

export const StyledRow = styled(Row) <{ unread: boolean }>`
  padding-top:18px;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue12};
    ${({ unread, theme }) => unread && `
      background-color: ${theme.colors.blue14};
    `}
  }

  &:active {
    background-color:  ${({ theme }) => theme.colors.blue14};
    ${({ unread, theme }) => unread && `
      background-color: ${theme.colors.blue15};
    `}
  }
`;

export const StyledLink = styled<FC<InternalLinkProps>>(InternalLink)`
  color: ${({ theme }) => theme?.colors.text};
  text-decoration : none;
  padding : 0px;
  margin:0px;
  width:100%;

  &:hover {
    text-decoration : none;
}

&:active {
  text-decoration : none;
}
`;
